import { keepPreviousData, useMutation, useQuery } from '@tanstack/react-query';

import { AxiosError, AxiosResponse } from 'axios';

import { api } from '.';

type GetParamsType = {
	page?: number;
	search_category?: string;
	search?: string;
	type?: string;
	row?: number;
};

export type Forum = {
	admin_name: string;
	forum_enrollment_date: string;
	forum_hit: number;
	forum_pk: number;
	forum_title: string;
	forum_image_url: string;
};

export type Newsletter = {
	admin_name: string;
	newsletter_enrollment_date: string;
	newsletter_hit: number;
	newsletter_pk: number;
	newsletter_title: string;
	newsletter_image_url: string;
};

export type Gallery = {
	admin_name: string;
	gallery_enrollment_date: string;
	gallery_hit: number;
	gallery_pk: number;
	gallery_title: string;
	gallery_image_url: string;
};

export type Trend = {
	admin_name: string;
	trend_enrollment_date: string;
	trend_hit: number;
	trend_pk: number;
	trend_title: string;
	trend_image_url: string;
};
type GetInfoResType = {
	gallery?: Gallery[];
	forum?: Forum[];
	newsletter?: Newsletter[];
	trend?: Trend[];
	trend_count: number;
	forum_count: number;
	newsletter_count: number;
	gallery_count: number;
};

export const useGetInfoApi = (params: GetParamsType) => {
	const url = '/v1/front/getInfo';
	return useQuery<AxiosResponse, AxiosError, GetInfoResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params),
		select: (res) => res.data.data,
	});
};
type GetInfoDetailParamsType = {
	info_pk: number | string;
	type: string;
};

export type GalleryDetail = {
	admin_pk: number;
	file_pk: number;
	admin_name: string;
	gallery_content: string;
	gallery_enrollment_date: string;
	gallery_exposure_yn: string;
	gallery_hit: number;
	gallery_image_type: string;
	gallery_image_url: string;
	gallery_pk: number;
	gallery_title: string;
	gallery_update_date: string;
	gallery_video_url: string;
};

export type ForumDetail = {
	admin_pk: number;
	admin_name: string;
	forum_content: string;
	forum_enrollment_date: string;
	forum_exposure_seq: string;
	forum_exposure_yn: string;
	forum_hit: number;
	forum_pk: number;
	forum_title: string;
	forum_update_date: string;
};

export type NewsletterDetail = {
	admin_pk: number;
	admin_name: string;
	newsletter_content: string;
	newsletter_enrollment_date: string;
	newsletter_exposure_yn: string;
	newsletter_hit: number;
	newsletter_pk: number;
	newsletter_title: string;
	newsletter_update_date: string;
};

export type TrendDetail = {
	admin_pk: number;
	admin_name: string;
	trend_content: string;
	trend_enrollment_date: string;
	trend_exposure_yn: string;
	trend_hit: number;
	trend_pk: number;
	trend_title: string;
	trend_update_date: string;
	trend_video_url: string;
};

export type FileDetail = {
	file_original_name: string;
	file_path: string;
	file_size: number;
	file_pk: string;
};

export type InfoDetailResType = {
	gallery?: GalleryDetail;
	forum?: ForumDetail;
	newsletter?: NewsletterDetail;
	trend?: TrendDetail;
	forum_file: FileDetail[];
	newsletter_file: FileDetail[];
	gallery_file: FileDetail[];
	trend_file: FileDetail[];
	next_pk: number;
	prev_pk: number;
};

export const useGetInfoDetailApi = (params: GetInfoDetailParamsType) => {
	const url = '/v1/front/getInfoDetail';
	return useQuery<AxiosResponse, AxiosError, InfoDetailResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params),
		select: (res) => res.data.data,
		placeholderData: keepPreviousData,
	});
};

export const useSaveForum = () => {
	const url = '/v1/front/saveForum';
	return useMutation<AxiosResponse, AxiosError, FormData>({
		mutationFn: (data) =>
			api.post(url, data, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			}),
	});
};
